<template>
  <div>
    <v-form ref="inputForm" @submit.prevent="">

      <v-row>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.MemberTitleID"
            v-model="model.memberTitleID" 
            :items="titlesDS" 
            :label="elsLabel.MemberTitleID"
            :helperText="elsHelperText.MemberTitleID"
            :rules="[elsRequired.MemberTitleID ? rules.required : true]">
          </Combobox>
        </v-col>
        <v-col cols="12" md="6" style="padding:0"></v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <TextField
            maxlength="20"
            v-model="model.firstName" 
            v-if="elsInUse.FirstName"
            :label="elsLabel.FirstName"
            :helperText="elsHelperText.FirstName"
            :rules="[rules.text, elsRequired.FirstName ? rules.required : true]">
          </TextField>
        </v-col>
        <v-col cols="12" md="6">
          <TextField 
            maxlength="40"
            v-model="model.surname" 
            v-if="elsInUse.Surname"
            :label="elsLabel.Surname"
            :helperText="elsHelperText.Surname"
            :rules="[rules.text, elsRequired.Surname ? rules.required : true]">
          </TextField>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <TextField
            type="email"
            maxlength="50"
            v-model="model.email" 
            v-if="elsInUse.EMail"
            :label="elsLabel.EMail"
            :helperText="elsHelperText.EMail"
            :rules="[rules.email, elsRequired.EMail ? rules.required : true]">
          </TextField>
        </v-col>
        <v-col cols="12" md="6">
          <TextField 
            type="email"
            maxlength="50"
            v-model="model.confirmEmail" 
            v-if="elsInUse.ConfirmEMail"
            :label="elsLabel.ConfirmEMail"
            :helperText="elsHelperText.ConfirmEMail"
            :rules="[rules.email, elsRequired.ConfirmEMail ? rules.required : true, generic.getString(model.email) === generic.getString(model.confirmEmail) || $let('NoMatchingEmails')]">
          </TextField>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <TextField
            :disabled="true"
            v-model="model.mobileNumber" 
            v-if="elsInUse.MobileNumber"
            :label="elsLabel.MobileNumber"
            :helperText="elsHelperText.MobileNumber">
          </TextField>
        </v-col>
        <v-col cols="12" md="6">
          <TextField
            maxlength="20"
            v-model="model.homePhoneNumber" 
            v-if="elsInUse.HomePhoneNumber"
            :label="elsLabel.HomePhoneNumber"
            :helperText="elsHelperText.HomePhoneNumber"
            :rules="[rules.ukLandLine, elsRequired.HomePhoneNumber ? rules.required : true]">
          </TextField>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <TextField 
            maxlength="9"
            v-model="model.nin"
            :disabled="ninDisabled"
            v-if="elsInUse.NINumber"
            :label="elsLabel.NINumber"
            :helperText="elsHelperText.NINumber"
            :rules="[rules.nin, elsRequired.NINumber ? rules.required : true]">
          </TextField>
        </v-col>
        <v-col cols="12" md="6" v-if="elsInUse.MemberNumber && isMember">
          <TextField 
            maxlength="50"
            v-model="model.memberNumber" 
            :disabled="memberNumberDisabled"
            v-if="elsInUse.MemberNumber && isMember"
            :label="elsLabel.MemberNumber"
            :helperText="elsHelperText.MemberNumber"
            :rules="[rules.text, isMember ? true : (elsRequired.MemberNumber ? rules.required : true)]">
          </TextField>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <DatePicker
            v-model="model.dateOfBirth"
            v-if="elsInUse.DateOfBirth"
            :label="elsLabel.DateOfBirth"
            :useIcon="true"
            :birthdayMode="true"
            :hint="elsHelperText.DateOfBirth"
            :helperText="elsHelperText.DateOfBirth"
            :max="maxDateOfBirth"
            :min="minDateOfBirth"
            :rules="[elsRequired.DateOfBirth ? rules.required : true]">
          </DatePicker>
        </v-col>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.Gender"
            v-model="model.gender"
            :items="gendersDS"
            :label="elsLabel.Gender"
            :helperText="elsHelperText.Gender"
            :rules="[elsRequired.Gender ? rules.required : true]">
          </Combobox>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.NationalityID"
            v-model="model.nationalityID"
            :items="nationalityDS"
            :label="elsLabel.NationalityID"
            :helperText="elsHelperText.NationalityID"
            :rules="[elsRequired.NationalityID ? rules.required : true]">
          </Combobox>
        </v-col>
        <v-col cols="12" md="6">
          <TextField 
            maxlength="10"
            v-model="model.payrollNumber" 
            v-if="elsInUse.PayrollNumber"
            :label="elsLabel.PayrollNumber"
            :helperText="elsHelperText.PayrollNumber"
            :rules="[rules.text, elsRequired.PayrollNumber ? rules.required : true]">
          </TextField>
        </v-col>        
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.LoanDetailDescriptionID && useLoanDetailDescription"
            v-model="model.loanDetailDescriptionID" 
            :items="loanDetailDescriptionDS" 
            :label="elsLabel.LoanDetailDescriptionID"
            :helperText="elsHelperText.LoanDetailDescriptionID"
            :rules="[elsRequired.LoanDetailDescriptionID ? rules.required : true]">
          </Combobox>
        </v-col>
        <v-col cols="12" md="6" style="padding:0"></v-col>
      </v-row>      

      <v-row>
        <v-col>
          <StepperButtons
            :backAvailable="false"
            @continueClick="_stepperContinue">
          </StepperButtons>
        </v-col>
      </v-row>

    </v-form>
  </div>
</template>

<script>

  import { mapState, mapGetters } from "vuex";
  import TextField from '@/shared/components/text-field.vue';
  import Combobox from '@/shared/components/combobox.vue';
  import DatePicker from '@/shared/components/date-picker.vue';
  import StepperButtons from './stepper-buttons.vue';
  import generic from '@/shared/utils/generic.js';
  import opmGeneric from '../utils/generic.js';
  import paramKeys from '../constants/param-keys.js';

  export default {
    name: 'PersonalDetails',
    components: { 
      StepperButtons, 
      DatePicker,
      TextField, 
      Combobox
    },
    props: {
      rules: { type: Object },
    },
    emits: ["continueClick"],
    data: () => ({
      generic,
      titlesDS: [],
      gendersDS: [],
      nationalityDS: [],
      loanDetailDescriptionDS: [],
      useLoanDetailDescription: false,
      ninDisabled: false,
      memberNumberDisabled: false,
      maxDateOfBirth: undefined,
      minDateOfBirth: undefined,
      model: {
        memberTitleID: undefined,
        firstName: undefined,
        surname: undefined,
        email: undefined,
        confirmEmail: undefined,
        mobileNumber: undefined,
        homePhoneNumber: undefined,
        nin: undefined,
        memberNumber: undefined,
        dateOfBirth: undefined,
        gender: undefined,
        nationalityID: undefined,
        payrollNumber: undefined, 
        loanDetailDescriptionID: undefined, 
      },
    }),
    created() {
      opmGeneric.setElementsConfig(this, this.elementsConfig);

      // Minimum Age to apply for membership
      this.maxDateOfBirth = (new Date()).dateAdd(-1 * parseInt(generic.filterValue(this.referenceData.SystemSettings, paramKeys.MinimumAge)));
      this.minDateOfBirth = (new Date()).dateAdd(-100);
      this.useLoanDetailDescription = generic.parseBoolValue(generic.filterValue(this.referenceData.SystemSettings, paramKeys.UseLoanDetailDescription));

      // DropdownLists sources
      this.titlesDS = this.referenceData ? this.referenceData.PersonalTitles : [];
      this.gendersDS = this.referenceData ? this.referenceData.Genders : [];
      this.nationalityDS = this.referenceData ? this.referenceData.Nationalities : [];
      this.loanDetailDescriptionDS = this.referenceData ? this.referenceData.LoanDetails : [];
      
      // Already collected data
      this.model.mobileNumber = this.$store.state.loanEnquiryData.mobileNumber;
      this.model.nin = this.$store.state.loanEnquiryData.nin;
      this.model.memberNumber = this.$store.state.loanEnquiryData.memberNumber;

      // Disable inputs that already have been collected
      this.ninDisabled = !!this.model.nin;
      this.memberNumberDisabled = !!this.model.memberNumber;
    },
    methods: {
      _stepperContinue() {
        this.$emit("continueClick", this.model, this.$refs.inputForm);
      }
    },
    computed: {
      ...mapGetters(["referenceData", "elementsConfig"]),
      ...mapState({
        isMember: (state) => state.loanEnquiryData.isMember,
      }),
    }
  };
</script>